import IntentExecutor from "../../intentexecutor/IntentExecutor";
import { getContext } from "../../intentexecutor/contextcreator/ContextCreator";

export const executeIntent = async (intentType, payload, context) => {
    let currentContext = context;
    if (context === undefined) {
        currentContext = getContext();
    }
    const intentExecutor = new IntentExecutor();
    const result = await intentExecutor.executeIntent(intentType, payload, currentContext, null);
    return result;
};
